.rectangle {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    print-color-adjust: exact;
    border: 2px solid transparent;

    &[data-periode-color='GREENSTRIPED'] {
        background: linear-gradient(
            45deg,
            var(--ax-success-400) 0%,
            var(--ax-success-400) 25%,
            var(--ax-bg-default) 25%,
            var(--ax-bg-default) 40%,
            var(--ax-success-400) 40%,
            var(--ax-success-400) 60%,
            var(--ax-bg-default) 60%,
            var(--ax-bg-default) 75%,
            var(--ax-success-400) 75%,
            var(--ax-success-400) 100%,
            var(--ax-bg-default) 100%
        );
        border-color: var(--ax-success-500);
    }

    &[data-periode-color='BLUESTRIPED'] {
        background: linear-gradient(
            45deg,
            var(--ax-accent-400) 0%,
            var(--ax-accent-400) 25%,
            var(--ax-bg-default) 25%,
            var(--ax-bg-default) 40%,
            var(--ax-accent-400) 40%,
            var(--ax-accent-400) 60%,
            var(--ax-bg-default) 60%,
            var(--ax-bg-default) 75%,
            var(--ax-accent-400) 75%,
            var(--ax-accent-400) 100%,
            var(--ax-bg-default) 100%
        );
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='LIGHTBLUEGREEN'] {
        background: linear-gradient(
            to top,
            var(--ax-success-400),
            var(--ax-success-400) 50%,
            var(--ax-accent-300) 50%,
            var(--ax-accent-300) 100%
        );
        border-color: var(--ax-success-400);
    }

    &[data-periode-color='LIGHTGREENBLUE'] {
        background: linear-gradient(
            to top,
            var(--ax-accent-400),
            var(--ax-accent-400) 50%,
            var(--ax-success-200) 50%,
            var(--ax-success-200) 100%
        );
        border-color: var(--ax-accent-400);
    }

    &[data-periode-color='BLUEOUTLINE'] {
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='BEIGEOUTLINE'] {
        border-color: var(--ax-brand-beige-600);
    }

    &[data-periode-color='BLACKOUTLINE'] {
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='GREEN_WITH_BLACK_OUTLINE'] {
        background-color: var(--ax-success-400);
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='BLUE_WITH_BLACK_OUTLINE'] {
        background-color: var(--ax-accent-400);
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='GREENOUTLINE'] {
        border-color: var(--ax-success-400);
    }

    &[data-periode-color='BLACK'] {
        background-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='GREEN'],
    &[data-periode-color='LIGHTGREEN'] {
        border-color: var(--ax-success-600);
        background-color: var(--ax-success-400);
    }

    &[data-periode-color='BLUE'],
    &[data-periode-color='LIGHTBLUE'] {
        background-color: var(--ax-accent-400);
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='GRAY'] {
        border-color: var(--ax-neutral-500);
        background-color: var(--ax-neutral-100);
    }

    &[data-periode-color='DARKGRAY'] {
        border-color: var(--ax-neutral-500);
        background-color: var(--ax-neutral-400);
    }
}
